// TanStack Query клиент с дефолтами для admin SPA.
// См. docs/stack/07-frontend-vite.md §4 — query keys всегда содержат tenantId/branchId; мутации без авто-retry.

import { QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiError } from './api';

// Простой toast-канал. В Sprint 1+ заменим на полноценный (sonner/react-hot-toast).
// Код ошибки печатаем отдельным полем — чтобы грепать в консоли/логе по коду.
function notifyError(message: string, code?: string): void {
  if (typeof window === 'undefined') return;
  // eslint-disable-next-line no-console
  console.error('[query]', code ?? '-', message);
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 2,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        const message =
          error instanceof ApiError
            ? (error.problem.title ?? error.problem.detail ?? `HTTP ${error.status}`)
            : error instanceof Error
              ? error.message
              : 'Неизвестная ошибка запроса';
        notifyError(message, error instanceof ApiError ? error.code : undefined);
      },
    }),
  });
}

// Singleton-инстанс для main.tsx — тесты создают свой через createQueryClient().
export const queryClient: QueryClient = createQueryClient();
